<template>
  <li class="block-list__item">
    {{ address.firstname }} {{ address.lastname }}<br />{{ address.address1 }}
    {{ address.address2 }}, {{ address.address3 }} {{ address.address4
    }}<br />{{ address.city }}
    {{ address.zipcode }}

    <div class="block-list__actions">
      <v-button
        :loading="removing"
        class="block-list__action block-list__action--edit"
        smallest
        @click="goToEdit"
        >{{ $t('actions.edit') }}</v-button
      >
      <v-button
        :loading="removing"
        class="block-list__action block-list__action--remove"
        smallest
        color="danger"
        @click="removeAddress($event)"
      >
        {{ $t('actions.remove') }}
      </v-button>
    </div>
  </li>
</template>

<script>
import VButton from '~/components/v-button/VButton'

export default {
  name: 'MyAddress',
  components: {
    VButton,
  },
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      removing: false,
    }
  },
  methods: {
    goToEdit() {
      this.$router.push(`/addresses/${this.address.id}/edit`)
    },
    async removeAddress(e) {
      const addressContent = e?.target?.closest('.block-list__item')
      if (!addressContent) return

      this.removing = true
      const params = {
        ...this.$store.getters.storeInfo,
      }

      try {
        await this.$apiv2.$delete(`addresses/${this.address.id}`, {
          params,
        })
        this.$displayTopMessage(this.$t('address_book.successfully_removed'))
        addressContent.remove()
      } catch (err) {
        this.$displayTopMessage(this.$t('action_error'), {
          type: 'error',
        })
      } finally {
        this.false = true
      }
    },
  },
}
</script>

<style lang="scss">
@import '~/assets/css/btn.scss';

.block-list__actions {
  display: flex;
  justify-content: space-between;
  width: 150px;

  .block-list__action {
    min-width: 70px;
  }
}
</style>
